<app-header [progress]="3" [title]="locale.currentTranslation.documentUploadHeader" data-testid="police-report-upload-header"></app-header>
<div class="base-content-container" data-testid="police-report-upload-container">
  <div class="headline3" data-testid="police-report-upload-title">{{ locale.currentTranslation.documentUploadPoliceReport1 }}
  </div>

  @for (option of options; track option) {
    <div class="radio-button-base" [attr.data-testid]="'radio-option-' + option.value">
      <div>
        <input type="radio"
               [value]="option.value"
               [formControl]="radioControl"
               [attr.data-testid]="'radio-input-' + option.value"
               [attr.aria-labelledby]="'radio-label-' + option.value">
      </div>
      <div (click)="setOption(option.value)" [attr.data-testid]="'radio-label-container-' + option.value">
        <div class="label1" [attr.id]="'radio-label-' + option.value" [attr.data-testid]="'radio-headline-' + option.value">{{ option.headline }}</div>
        <div class="caption1" [attr.data-testid]="'radio-caption-' + option.value">{{ option.caption }}</div>
      </div>
    </div>
  }
  <div class="divider"></div>
  @if (radioControl.getRawValue() === true && radioControl.getRawValue() !== null) {
    <div style="display: flex; gap: 16px; flex-wrap: wrap;" data-testid="police-report-upload-section">
      @for (imageUrl of imageUrls; track imageUrl) {
        <div
          style="position: relative; width: 56px; height: 56px;">
          <app-image class="upload-element" [src]="imageUrl" [height]="56" [width]="56" [attr.data-testid]="'uploaded-police-report-' + imageUrl"></app-image>
          <img
            src="assets/img/remove-image-button.svg"
            height="16"
            width="16"
            style="position: absolute; top: -4px; right: -4px; cursor: pointer;"
            (click)="removeImage(imageUrl)"
            [attr.data-testid]="'remove-police-report-' + imageUrl"
            role="button"
            tabindex="0"
            alt="Remove police report image"
          />
        </div>
      }
      @if (isLoading()) {
        <app-spinner data-testid="upload-spinner"/>
      } @else {
        <div class="upload-button upload-element" (click)="triggerFileInput()" data-testid="btn-upload-police-report" role="button" tabindex="0" aria-label="Upload police report images"></div>
      }
      <input #fileInput type="file" hidden accept="image/*" (change)="onFileSelected($event)" data-testid="file-input-police-report"/>
    </div>
  }
  @if (radioControl.getRawValue() === false && radioControl.getRawValue() !== null) {
    <div data-testid="no-police-report-section">
      <div class="card-info" data-testid="info-card">
        <div style="display: flex; align-items: center; gap: 8px;">
          <img ngSrc="../../../../../assets/img/info-icon.svg" height="20" width="20">
          <div class="headline4" style="color: #0A1535;">{{ locale.currentTranslation.important }}</div>
        </div>
        <div class="text-body2">
          <div>
            {{ locale.currentTranslation.policeReportUpload2 }}
          </div>
        </div>
      </div>
      <div style="margin-top: 24px;">
        <app-text-area
          [(value)]="policeReportNotAvailableReason"
          [placeholder]="locale.currentTranslation.policeReportUploadPlaceholder"
          [required]="true"
          [showError]="showError"
          (valueChange)="showError = false"
          data-testid="textarea-no-police-reason"
          [attr.aria-label]="locale.currentTranslation.policeReportUploadPlaceholder"
        ></app-text-area>
      </div>
    </div>
  }
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.policeReportUploadErrorMessage }}
    </div>
  }

</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="police-report-upload-footer"></app-footer>
